import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'


class IndexBloc {

    exportUsulanChannel = new Subject();

    indexChannel = new Subject()
    repository = new IndexRepository()

    constructor() {
        this.indexChannel.next({status: apiResponse.INITIAL})
    }

    fetchExportUsulan = async (query) => {
        this.exportUsulanChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchExportUsulan(query).then((result) => {
            this.exportUsulanChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.exportUsulanChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default IndexBloc